import React, { useEffect, useState } from "react";

// SOFTCAT 디자인 시스템 별점 입력 (sc-stars--input)
const RATING_MESSAGES = {
    0: "별점을 선택해주세요",
    1: "별로다옹",
    2: "아쉽다옹",
    3: "보통이다옹",
    4: "만족이다옹",
    5: "최고다옹",
};

const ReviewStars = ({ onRatingChange }) => {
    const [rating, setRating] = useState(0);
    const [hoverRating, setHoverRating] = useState(0);

    // 의존성 배열이 없으면 매 렌더마다 부모 콜백이 호출돼
    // 부모가 상태를 갱신할 경우 무한 렌더가 된다. rating이 바뀔 때만 알린다.
    useEffect(() => {
        onRatingChange(rating);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rating]);

    const shown = hoverRating || rating;

    return (
        <div className="sch-reviewstars">
            <p className="sc-label">별점을 선택해주세요</p>

            <div className="sc-stars sc-stars--input" onMouseLeave={() => setHoverRating(0)}>
                {[1, 2, 3, 4, 5].map((index) => (
                    <button
                        type="button"
                        key={index}
                        className={shown >= index ? "on" : ""}
                        onMouseEnter={() => setHoverRating(index)}
                        onFocus={() => setHoverRating(index)}
                        onClick={() => setRating(index)}
                        aria-label={`${index}점`}
                        aria-pressed={rating === index}
                    >
                        ★
                    </button>
                ))}
            </div>

            <p className="sc-body-sm" style={{ color: "var(--text-secondary)" }}>
                {rating}점 (<b>{RATING_MESSAGES[rating]}</b>)을 남겨주셨네요. 구체적인 내용을 작성해 주세요!
            </p>
        </div>
    );
};

export default ReviewStars;
